import React, { useState } from 'react';
import { ImgixLazyImage } from '@tv2/lib-offspring/components/image/ImgixLazyImage';
import { PlayBasicNext } from '@tv2/ui-system/icons/next/audio-video/PlayBasicNext';
import { isMobile } from '@tv2/lib-offspring/libs/isMobile';
import Watermark from '@tv2/lib-offspring/components/watermark/Watermark';
import ProgressBar from '../../../../ProgressBar';
import { Label } from '../../../../Label';
import { Link } from '../../../../Link';
import { CardAction } from '../actions/CardAction';
import { CardProps, VodCardActionButton, VodCardButton } from './VodCard';

export function VodCardLandscape({ card, cardSize, actions }: CardProps): React.ReactNode {
  const [showOverlay, setShowOverlay] = useState(false);

  const hasCardActions = Boolean(card.actions?.length);
  const showActionsTint = showOverlay && hasCardActions;
  const tintClass = showActionsTint ? 'bg-opacity-midnight-700' : '';

  return (
    <Link key={card.id} destination={card.destination} action={card.action} onAction={actions}>
      <div
        onClick={() => {
          if (isMobile()) {
            setShowOverlay(x => !x);
          }
        }}
        onMouseEnter={e => {
          if (isMobile()) {
            e.preventDefault();
            return;
          }
          setShowOverlay(true);
        }}
        onMouseLeave={e => {
          if (isMobile()) {
            e.preventDefault();
            return;
          }
          setShowOverlay(false);
        }}
        className="relative hover:scale-s 2xl:hover:scale-xs transition-transform pb-1 group"
        aria-label={card.title ?? ''}
      >
        <div className="relative">
          <ImgixLazyImage src={card.imageUrl || ''}></ImgixLazyImage>
          <div
            className={`absolute inset-0 ease-out transition duration-[400ms] ${tintClass} overflow-hidden`}
          ></div>
          <div className="absolute inset-0 flex justify-center items-center">
            {card.button ? (
              <div className="absolute inset-0">
                <VodCardButton card={card} active={false} />
              </div>
            ) : (
              <div className="w-12 h-12 bg-opacity-midnight-700 group-hover:bg-white-hover rounded-full flex justify-center items-center">
                <PlayBasicNext className="h-6 w-6 invert group-hover:invert-0" />
              </div>
            )}
          </div>
          {card.logoUrl && (
            <Watermark alt={card.title ?? ''} title={card.title ?? ''} src={card.logoUrl} />
          )}
          <div className="absolute right-2 top-2 flex flex-col items-end">
            {card.actionButton ? (
              <VodCardActionButton
                card={card}
                actions={actions}
                onShowActionsModal={() => setShowOverlay(x => !x)}
              />
            ) : null}
            {showOverlay &&
              card.actions?.map((action, index) => (
                <CardAction key={index} cardAction={action} actions={actions} />
              ))}
          </div>
        </div>
        <div className="flex flex-row">
          {card.labels.map(label => (
            <Label key={label.text} label={label} />
          ))}
        </div>
        <div
          className={`${
            cardSize === 'SMALL' || cardSize === 'XSMALL' ? 'text-heading-xs' : 'text-heading-s'
          } mt-2 mb-0 pb-0 overflow-hidden line-clamp-2 text-white`}
        >
          {card.title}
        </div>
        {card.subTitle && (
          <div className="mt-2 text-midnight-400 text-marker-xs line-clamp-1">{card.subTitle}</div>
        )}
        {card.button == null && card.progress?.percentage ? (
          <div className="mt-2">
            <ProgressBar progress={card.progress.percentage} />
          </div>
        ) : null}
      </div>
    </Link>
  );
}
